import { render, staticRenderFns } from "./GoalListMandalaSection.vue?vue&type=template&id=3c7be7b0&scoped=true&"
import script from "./GoalListMandalaSection.vue?vue&type=script&lang=js&"
export * from "./GoalListMandalaSection.vue?vue&type=script&lang=js&"
import style0 from "./GoalListMandalaSection.vue?vue&type=style&index=0&id=3c7be7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7be7b0",
  null
  
)

export default component.exports